import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, isMemoSame as _isMemoSame, withMemo as _withMemo, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-df1de7a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 right-0 h-full w-full md:w-[560px] bg-[#141a24] border-l border-gray-700 shadow-2xl z-50 overflow-y-auto"
}
const _hoisted_2 = { class: "flex items-center justify-between p-4 border-b border-gray-700 sticky top-0 bg-[#141a24] z-10" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "w-10 h-10 rounded-full bg-[#219152] flex items-center justify-center text-white font-bold" }
const _hoisted_5 = { class: "font-semibold text-white" }
const _hoisted_6 = { class: "text-xs text-gray-400" }
const _hoisted_7 = {
  key: 0,
  class: "p-8 text-center text-gray-400"
}
const _hoisted_8 = {
  key: 1,
  class: "p-4 space-y-6"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xs uppercase tracking-wider text-gray-400 mb-2" }, "Identité", -1))
const _hoisted_10 = { class: "grid grid-cols-2 gap-x-4 gap-y-2 text-sm" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-gray-400" }, "Statut", -1))
const _hoisted_12 = { class: "text-white" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-gray-400" }, "Téléphone", -1))
const _hoisted_14 = { class: "text-white" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-gray-400" }, "Matricule", -1))
const _hoisted_16 = { class: "text-white" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-gray-400" }, "Inscription", -1))
const _hoisted_18 = { class: "text-white" }
const _hoisted_19 = { class: "text-xs uppercase tracking-wider text-gray-400 mb-2" }
const _hoisted_20 = { class: "text-gray-500" }
const _hoisted_21 = { class: "flex flex-wrap gap-2 mb-3" }
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = {
  key: 0,
  class: "text-gray-500 text-xs italic"
}
const _hoisted_24 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "+ Ajouter une agence…", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "text-xs uppercase tracking-wider text-gray-400 mb-2" }
const _hoisted_29 = { class: "text-gray-500" }
const _hoisted_30 = { class: "flex flex-wrap gap-2 mb-3" }
const _hoisted_31 = { class: "text-gray-400 text-[10px]" }
const _hoisted_32 = ["onClick", "disabled"]
const _hoisted_33 = {
  key: 0,
  class: "text-gray-500 text-xs italic"
}
const _hoisted_34 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "+ Ajouter un rôle…", -1))
const _hoisted_36 = ["value"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "text-xs uppercase tracking-wider text-gray-400 mb-2" }
const _hoisted_39 = { class: "text-gray-500" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 mb-2 italic" }, "Dérivées des rôles assignés. Non modifiables directement.", -1))
const _hoisted_41 = {
  key: 0,
  class: "space-y-1 max-h-80 overflow-y-auto pr-2"
}
const _hoisted_42 = { class: "text-white font-mono text-xs" }
const _hoisted_43 = { class: "flex flex-wrap gap-1" }
const _hoisted_44 = {
  key: 1,
  class: "text-gray-500 text-xs italic"
}
const _hoisted_45 = { class: "bg-[#1b232e] border border-gray-600 rounded-lg shadow-2xl w-full max-w-sm overflow-hidden" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-4 border-b border-gray-700 flex items-center gap-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-9 h-9 rounded-full bg-red-500/15 border border-red-500/40 flex items-center justify-center text-red-400 text-lg" }, "!"),
  /*#__PURE__*/_createElementVNode("h4", { class: "text-white font-semibold text-sm" }, "Retirer l'agence")
], -1))
const _hoisted_47 = { class: "p-4 space-y-3" }
const _hoisted_48 = { class: "text-sm text-gray-300" }
const _hoisted_49 = { class: "font-semibold text-blue-300" }
const _hoisted_50 = { class: "font-semibold text-white" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, " L'utilisateur perdra l'accès aux données opérationnelles de cette agence. ", -1))
const _hoisted_52 = { class: "p-3 bg-black/20 border-t border-gray-700 flex justify-end gap-2" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "bg-[#1b232e] border border-gray-600 rounded-lg shadow-2xl w-full max-w-sm overflow-hidden" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-4 border-b border-gray-700 flex items-center gap-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-9 h-9 rounded-full bg-red-500/15 border border-red-500/40 flex items-center justify-center text-red-400 text-lg" }, "!"),
  /*#__PURE__*/_createElementVNode("h4", { class: "text-white font-semibold text-sm" }, "Retirer le rôle")
], -1))
const _hoisted_57 = { class: "p-4 space-y-3" }
const _hoisted_58 = { class: "text-sm text-gray-300" }
const _hoisted_59 = { class: "font-semibold text-green-300" }
const _hoisted_60 = { class: "font-semibold text-white" }
const _hoisted_61 = { class: "text-xs text-gray-500" }
const _hoisted_62 = { class: "p-3 bg-black/20 border-t border-gray-700 flex justify-end gap-2" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = ["disabled"]

import { ref, watch, computed } from "vue";
	import api from "@/api";
	import useAccess from "@/composable/useAccess";
	import useNotyf from "@/composable/useNotyf";
	import { refreshUserInfos, userID } from "@/state/api/userState";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetailDrawer',
  props: {
    open: { type: Boolean },
    userId: {},
    allRoles: {},
    allStations: {},
    stationUuid: {}
  },
  emits: ["close", "updated"],
  setup(__props: any, { emit: __emit }) {

	/**
	 * Consolidated user detail drawer — slides from the right.
	 *
	 * Perf choices:
	 *  - Full profile is fetched on-demand (only when the drawer opens)
	 *  - Roles list is cached at the parent level and passed as a prop (no re-fetch per open)
	 *  - Effective permissions are pre-grouped server-side, so the render cost is O(resources)
	 *  - v-memo locks the permission blocks against re-render while roles edit
	 */
	const props = __props;
	const emit = __emit;

	const notify = useNotyf();
	const profile = ref<any>(null);
	const isLoading = ref(false);
	const isMutating = ref(false);
	// Selected role's UUID (backend expects uuid string, not numeric id)
	const selectedRoleToAdd = ref<string | null>(null);
	// Pending role removal — holds the role object being confirmed, null when no prompt.
	const pendingRemoval = ref<any>(null);

	// Selected station UUID for assignment (backend uses station UUID).
	const selectedStationToAdd = ref<string | null>(null);
	// Pending station removal — holds the station object being confirmed.
	const pendingStationRemoval = ref<any>(null);

	// Assign/unassign agencies is reserved to Admin/CoAdmin/Root — same gate
	// as the top selector. Other roles see the chips read-only (no regression).
	const canManageStations = computed(() => useAccess("visibility", ["Admin", "CoAdmin", "Root"]));

	/**
	 * Station de référence pour assigner/retirer un RÔLE (les rôles sont scopés
	 * par agence côté API : attachRoles/detachRoles exigent un `station`).
	 *
	 * On prend la station globale sélectionnée (sélecteur du haut) si présente.
	 * Sinon — cas du Root qui n'a PAS de station courante — on retombe sur la
	 * 1ère agence assignée à l'utilisateur cible. Avant ce fallback, assigner
	 * un rôle en tant que Root échouait toujours avec « Aucune agence
	 * sélectionnée » alors que l'utilisateur avait bien une agence.
	 */
	const roleStationUuid = computed<string | null>(() =>
		props.stationUuid || profile.value?.stations?.[0]?.uuid || null
	);

	/**
	 * Quand un Admin modifie sa propre assignation, le `stations` retourné
	 * par /user/infos n'est plus à jour côté client → le sélecteur du
	 * haut reste figé. On re-fetch userInfos uniquement dans ce cas pour
	 * éviter un round-trip inutile pour les modifications sur autrui.
	 */
	const isSelfTarget = () => profile.value?.id != null && userID.value != null
		&& Number(profile.value.id) === Number(userID.value);

	const loadProfile = async (id: number) => {
		isLoading.value = true;
		profile.value = null;
		try {
			const r = await api().user.getProfile(id);
			profile.value = r.data;
		} catch (err) {
			console.error(err);
			notify.error("Impossible de charger le profil utilisateur");
		}
		isLoading.value = false;
	};

	// Lazy-load: only fetch when the drawer actually opens AND has an id
	watch(
		() => [props.open, props.userId] as const,
		([open, id]) => {
			if (open && id) loadProfile(id);
			if (!open) profile.value = null; // free memory when closed
		},
		{ immediate: true }
	);

	const availableRolesToAdd = computed(() => {
		const assigned = new Set((profile.value?.roles || []).map((r: any) => r.uuid));
		return (props.allRoles || []).filter((r: any) => !assigned.has(r.uuid));
	});

	const availableStationsToAdd = computed(() => {
		const assigned = new Set((profile.value?.stations || []).map((s: any) => s.uuid));
		// Un utilisateur appartient à une seule entreprise : on ne propose
		// que les agences de son entreprise. Sans ce filtre, un Root
		// connecté voit toutes les agences de toutes les entreprises
		// dans le dropdown (cf. screenshot — Koutaba, Magba, Foumban…).
		const targetEnterpriseId = profile.value?.enterprise_id;
		return (props.allStations || []).filter((s: any) => {
			if (assigned.has(s.uuid)) return false;
			if (targetEnterpriseId != null && s.enterprise_id != null) {
				return Number(s.enterprise_id) === Number(targetEnterpriseId);
			}
			return true;
		});
	});

	const assignRole = async () => {
		if (!selectedRoleToAdd.value || !props.userId || !profile.value?.uuid) return;
		if (!roleStationUuid.value) {
			notify.error("Assignez d'abord une agence à l'utilisateur");
			return;
		}
		isMutating.value = true;
		try {
			await api().user.attachRoles({
				station: roleStationUuid.value,
				user: profile.value.uuid,
				roles: [{ uuid: selectedRoleToAdd.value }],
			});
			notify.success("Rôle assigné");
			selectedRoleToAdd.value = null;
			await loadProfile(props.userId);
			emit("updated");
		} catch (err) {
			console.error(err);
			notify.error("Erreur lors de l'assignation");
		}
		isMutating.value = false;
	};

	const askRemoveRole = (role: any) => {
		pendingRemoval.value = role;
	};

	const cancelRemoval = () => {
		pendingRemoval.value = null;
	};

	const confirmRemoveRole = async () => {
		if (!pendingRemoval.value || !props.userId || !profile.value?.uuid) return;
		if (!roleStationUuid.value) {
			notify.error("Assignez d'abord une agence à l'utilisateur");
			return;
		}
		const roleUuid = pendingRemoval.value.uuid;
		const roleLabel = pendingRemoval.value.alias_fr || pendingRemoval.value.name;
		isMutating.value = true;
		try {
			await api().user.detachRoles({
				station: roleStationUuid.value,
				user: profile.value.uuid,
				roles: [{ uuid: roleUuid }],
			});
			notify.success(`Rôle « ${roleLabel} » retiré`);
			pendingRemoval.value = null;
			// Maj OPTIMISTE : on retire le chip immédiatement (les permissions
			// effectives, dérivées serveur, sont réconciliées par loadProfile).
			if (Array.isArray(profile.value?.roles)) {
				profile.value.roles = profile.value.roles.filter((r: any) => r.uuid !== roleUuid);
			}
			await loadProfile(props.userId);
			emit("updated");
		} catch (err) {
			console.error(err);
			notify.error("Erreur lors du retrait");
		}
		isMutating.value = false;
	};

	// --- Station assignment ---
	const assignStation = async () => {
		if (!selectedStationToAdd.value || !props.userId || !profile.value?.uuid) return;
		isMutating.value = true;
		const wasSelf = isSelfTarget();
		try {
			await api().user.attachStation({
				station: selectedStationToAdd.value,
				user: profile.value.uuid,
			});
			notify.success("Agence assignée");
			selectedStationToAdd.value = null;
			await loadProfile(props.userId);
			if (wasSelf) await refreshUserInfos();
			emit("updated");
		} catch (err: any) {
			console.error(err);
			if (err?.status === 403) notify.error("Vous n'avez pas la permission");
			else notify.error("Erreur lors de l'assignation");
		}
		isMutating.value = false;
	};

	const askRemoveStation = (station: any) => {
		pendingStationRemoval.value = station;
	};

	const cancelStationRemoval = () => {
		pendingStationRemoval.value = null;
	};

	const confirmRemoveStation = async () => {
		if (!pendingStationRemoval.value || !props.userId || !profile.value?.uuid) return;
		const stationUuid = pendingStationRemoval.value.uuid;
		const stationLabel = pendingStationRemoval.value.station_name;
		isMutating.value = true;
		const wasSelf = isSelfTarget();
		try {
			await api().user.detachStation({
				station: stationUuid,
				user: profile.value.uuid,
			});
			notify.success(`Agence « ${stationLabel} » retirée`);
			pendingStationRemoval.value = null;
			// Maj OPTIMISTE : on retire le chip agence immédiatement (loadProfile
			// réconcilie ensuite). Corrige le glitch où l'agence retirée restait
			// affichée jusqu'au ré-ouvrage du drawer.
			if (Array.isArray(profile.value?.stations)) {
				profile.value.stations = profile.value.stations.filter((s: any) => s.uuid !== stationUuid);
			}
			await loadProfile(props.userId);
			if (wasSelf) await refreshUserInfos();
			emit("updated");
		} catch (err: any) {
			console.error(err);
			// 422 = last station guard côté backend
			if (err?.status === 422) {
				notify.error("Impossible de retirer la dernière agence d'un utilisateur");
			} else if (err?.status === 403) {
				notify.error("Vous n'avez pas la permission");
			} else {
				notify.error("Erreur lors du retrait");
			}
		}
		isMutating.value = false;
	};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-black/50 z-40",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString((profile.value?.infos?.name || profile.value?.email || '?').charAt(0).toUpperCase()), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(profile.value?.infos?.name || '—') + " " + _toDisplayString(profile.value?.infos?.last_name || ''), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(profile.value?.email || '—'), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
                  class: "text-gray-400 hover:text-white text-2xl leading-none"
                }, "×")
              ]),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Chargement du profil…"))
                : (profile.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("section", null, [
                        _hoisted_9,
                        _createElementVNode("dl", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("dd", _hoisted_12, _toDisplayString(profile.value.status || '—'), 1),
                          _hoisted_13,
                          _createElementVNode("dd", _hoisted_14, _toDisplayString(profile.value.infos?.phone || '—'), 1),
                          _hoisted_15,
                          _createElementVNode("dd", _hoisted_16, _toDisplayString(profile.value.infos?.matricule || '—'), 1),
                          _hoisted_17,
                          _createElementVNode("dd", _hoisted_18, _toDisplayString(profile.value.created_at ? new Date(profile.value.created_at).toLocaleDateString('fr-FR') : '—'), 1)
                        ])
                      ]),
                      _createElementVNode("section", null, [
                        _createElementVNode("h3", _hoisted_19, [
                          _createTextVNode(" Agences assignées "),
                          _createElementVNode("span", _hoisted_20, "(" + _toDisplayString(profile.value.stations.length) + ")", 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.value.stations, (s) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: s.id,
                              class: "group flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 text-blue-300 border border-blue-500/30 text-xs"
                            }, [
                              _createElementVNode("span", null, _toDisplayString(s.station_name), 1),
                              (canManageStations.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (askRemoveStation(s)),
                                    disabled: isMutating.value,
                                    class: "opacity-0 group-hover:opacity-100 transition-opacity text-red-400 hover:text-red-300 disabled:opacity-40",
                                    title: "Retirer cette agence"
                                  }, "×", 8, _hoisted_22))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128)),
                          (!profile.value.stations.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Aucune agence"))
                            : _createCommentVNode("", true)
                        ]),
                        (canManageStations.value && availableStationsToAdd.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedStationToAdd).value = $event)),
                                class: "role-select flex-1 px-3 py-2 rounded border text-sm focus:outline-none"
                              }, [
                                _hoisted_25,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableStationsToAdd.value, (s) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: s.uuid,
                                    value: s.uuid
                                  }, _toDisplayString(s.station_name), 9, _hoisted_26))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, selectedStationToAdd.value]
                              ]),
                              _createElementVNode("button", {
                                onClick: assignStation,
                                disabled: !selectedStationToAdd.value || isMutating.value,
                                class: "bg-[#219152] text-white px-4 py-2 rounded hover:bg-[#167841] text-sm transition-colors disabled:bg-gray-600 disabled:cursor-not-allowed disabled:opacity-60"
                              }, _toDisplayString(isMutating.value ? '…' : 'Assigner'), 9, _hoisted_27)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("section", null, [
                        _createElementVNode("h3", _hoisted_28, [
                          _createTextVNode(" Rôles "),
                          _createElementVNode("span", _hoisted_29, "(" + _toDisplayString(profile.value.roles.length) + ")", 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.value.roles, (r) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: r.id,
                              class: "group flex items-center gap-2 px-3 py-1 rounded-full bg-[#219152]/15 text-green-300 border border-[#219152]/40 text-xs"
                            }, [
                              _createElementVNode("span", null, _toDisplayString(r.alias_fr || r.name), 1),
                              _createElementVNode("span", _hoisted_31, "· " + _toDisplayString(r.permissions_count) + " perm.", 1),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (askRemoveRole(r)),
                                disabled: isMutating.value,
                                class: "opacity-0 group-hover:opacity-100 transition-opacity text-red-400 hover:text-red-300 disabled:opacity-40",
                                title: "Retirer ce rôle"
                              }, "×", 8, _hoisted_32)
                            ]))
                          }), 128)),
                          (!profile.value.roles.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Aucun rôle"))
                            : _createCommentVNode("", true)
                        ]),
                        (availableRolesToAdd.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedRoleToAdd).value = $event)),
                                class: "role-select flex-1 px-3 py-2 rounded border text-sm focus:outline-none"
                              }, [
                                _hoisted_35,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRolesToAdd.value, (r) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: r.uuid,
                                    value: r.uuid
                                  }, _toDisplayString(r.alias_fr || r.name), 9, _hoisted_36))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, selectedRoleToAdd.value]
                              ]),
                              _createElementVNode("button", {
                                onClick: assignRole,
                                disabled: !selectedRoleToAdd.value || isMutating.value,
                                class: "bg-[#219152] text-white px-4 py-2 rounded hover:bg-[#167841] text-sm transition-colors disabled:bg-gray-600 disabled:cursor-not-allowed disabled:opacity-60"
                              }, _toDisplayString(isMutating.value ? '…' : 'Assigner'), 9, _hoisted_37)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("section", null, [
                        _createElementVNode("h3", _hoisted_38, [
                          _createTextVNode(" Permissions effectives "),
                          _createElementVNode("span", _hoisted_39, "(" + _toDisplayString(profile.value.effective_permissions_count) + ")", 1)
                        ]),
                        _hoisted_40,
                        (profile.value.effective_permissions.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.value.effective_permissions, (p, __, ___, _cached) => {
                                const _memo = ([p.resource, p.actions.length])
                                if (_cached && _cached.key === p.resource && _isMemoSame(_cached, _memo)) return _cached
                                const _item = (_openBlock(), _createElementBlock("div", {
                                  key: p.resource,
                                  class: "flex items-center justify-between py-1.5 px-3 bg-gray-800/50 rounded text-sm"
                                }, [
                                  _createElementVNode("span", _hoisted_42, _toDisplayString(p.resource), 1),
                                  _createElementVNode("div", _hoisted_43, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.actions, (a) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: a,
                                        class: "px-1.5 py-0.5 bg-gray-700 text-gray-300 rounded text-[10px]"
                                      }, _toDisplayString(a), 1))
                                    }), 128))
                                  ])
                                ]))
                                _item.memo = _memo
                                return _item
                              }, _cache, 4), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_44, "Aucune permission effective"))
                      ])
                    ]))
                  : _createCommentVNode("", true),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (pendingStationRemoval.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "absolute inset-0 bg-black/60 z-20 flex items-center justify-center p-4",
                        onClick: _withModifiers(cancelStationRemoval, ["self"])
                      }, [
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("p", _hoisted_48, [
                              _createTextVNode(" Retirer l'agence "),
                              _createElementVNode("span", _hoisted_49, _toDisplayString(pendingStationRemoval.value.station_name), 1),
                              _createTextVNode(" à "),
                              _createElementVNode("span", _hoisted_50, _toDisplayString(profile.value?.infos?.name || profile.value?.email), 1),
                              _createTextVNode(" ? ")
                            ]),
                            _hoisted_51
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: cancelStationRemoval,
                              disabled: isMutating.value,
                              class: "px-4 py-1.5 text-sm text-gray-300 bg-transparent border border-gray-600 rounded hover:bg-gray-700 transition-colors disabled:opacity-50"
                            }, "Annuler", 8, _hoisted_53),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: confirmRemoveStation,
                              disabled: isMutating.value,
                              class: "px-4 py-1.5 text-sm text-white bg-red-600 rounded hover:bg-red-700 transition-colors disabled:opacity-50"
                            }, _toDisplayString(isMutating.value ? 'Retrait…' : 'Retirer'), 9, _hoisted_54)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (pendingRemoval.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "absolute inset-0 bg-black/60 z-20 flex items-center justify-center p-4",
                        onClick: _withModifiers(cancelRemoval, ["self"])
                      }, [
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("p", _hoisted_58, [
                              _createTextVNode(" Retirer le rôle "),
                              _createElementVNode("span", _hoisted_59, _toDisplayString(pendingRemoval.value.alias_fr || pendingRemoval.value.name), 1),
                              _createTextVNode(" à "),
                              _createElementVNode("span", _hoisted_60, _toDisplayString(profile.value?.infos?.name || profile.value?.email), 1),
                              _createTextVNode(" ? ")
                            ]),
                            _createElementVNode("p", _hoisted_61, " Cette action retire les " + _toDisplayString(pendingRemoval.value.permissions_count) + " permission(s) associées à ce rôle pour cet utilisateur. ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: cancelRemoval,
                              disabled: isMutating.value,
                              class: "px-4 py-1.5 text-sm text-gray-300 bg-transparent border border-gray-600 rounded hover:bg-gray-700 transition-colors disabled:opacity-50"
                            }, "Annuler", 8, _hoisted_63),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: confirmRemoveRole,
                              disabled: isMutating.value,
                              class: "px-4 py-1.5 text-sm text-white bg-red-600 rounded hover:bg-red-700 transition-colors disabled:opacity-50"
                            }, _toDisplayString(isMutating.value ? 'Retrait…' : 'Retirer'), 9, _hoisted_64)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})